/*
 *
 * ColorRibbonBtn
 *
 */

import React from 'react';
import { Color } from 'lib/modelBuilder/entities/Color';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components/macro';
import ColorSelectedPreviewer from 'components/ColorSelectedPreviewer';
import { ColorPreviewItem } from 'containers/PanesPanel/selectors';
import useMedia from 'use-media';
import { FiChevronDown } from 'react-icons/fi';
import { IoMdColorFill } from 'react-icons/io';

interface Props {
  title: string;
  manageClick?: any;
  colors?: ColorPreviewItem[];
  colorDispositionColumn?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
}

function ColorRibbonBtn({
  title,
  manageClick,
  colors,
  colorDispositionColumn,
  disabled,
  disabledMessage,
}: Props) {
  const onClick = () => {
    manageClick();
  };
  const isXL = useMedia({ minWidth: 1280 });

  if (typeof disabled === 'undefined') disabled = false;

  return (
    <>
      <div data-tip={disabled ? disabledMessage : ''}>
        <button
          onClick={onClick}
          disabled={disabled}
          className={`py-1 ${isXL ? 'mx-2' : 'mx-1'}`}
        >
          <div className="flex items-center">
            <IoMdColorFill className="h-5 w-5 mr-1 text-main" />
            <TitleStyled disabled={disabled}>{title}</TitleStyled>
            <FiChevronDown className="mt-1 h-4 w-4" />
            {/*{colors && isXL && (
              <ColorSelectedPreviewer
                colors={colors}
                colorDispositionColumn={colorDispositionColumn}
              />
            )}*/}
          </div>
        </button>
      </div>
      <ReactTooltip place="bottom" type="warning" />
    </>
  );
}

export default ColorRibbonBtn;

const TitleStyled = styled.div<{ disabled?: boolean }>`
  color: ${props =>
    props.disabled ? props.theme.gray600 : props.theme.gray800};
`;
